import { render, staticRenderFns } from "./RTMPComponentNG.vue?vue&type=template&id=3cf4a508"
import script from "./RTMPComponentNG.vue?vue&type=script&lang=js"
export * from "./RTMPComponentNG.vue?vue&type=script&lang=js"
import style0 from "./RTMPComponentNG.vue?vue&type=style&index=0&id=3cf4a508&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports